var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "TrialCancellationContainer",
    {
      staticClass: "with-lg-subtitle-theme",
      attrs: {
        title: _vm.optionContent.title,
        subtitle: _vm.optionContent.subtitle
      },
      scopedSlots: _vm._u([
        {
          key: "after-title",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "illustration" },
                [_c("OrbitCalendarSvg")],
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c("TrialCancellationActionsUi", {
        attrs: {
          loading: _vm.loading,
          "abort-btn-text": _vm.optionContent.abortBtnText
        },
        on: {
          continue: function($event) {
            return _vm.actionHandler("next")
          },
          abort: function($event) {
            return _vm.actionHandler("abort")
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }